var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "atlas-datetime-select",
      attrs: { id: "atlas-datetime-select" }
    },
    [
      _c("QpeDatetime", {
        attrs: {
          props_date: _vm.date,
          props_time: _vm.time,
          name: _vm.default_value
        },
        on: {
          "update-time": _vm.update_time,
          "change-parent-date-time": _vm.change_parent_date_time
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }